import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import loading from '../images/loading.gif'
import logo from '../images/logo.jpeg'


const UserProfile = () => {
  const [datas, setDatas] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [error, setError] = useState(null);
  const { id } = useParams();



  // Fetch user data
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_API}/user/${id}`);
       
        

        if (data) {
          setDatas(data.data);
        }


      } catch (err) {
        setError("Failed to fetch data. Please try again.");
      } finally {
        setIsLoading(false)
      }
    };
    fetchUserData()
  }, [id]);

  return (
    <div className="grid items-center">
      <div className="min-h-screen bg-gray-100 text-center flex flex-col items-center p-4">
      
        <div className="max-w-sm w-full mx-auto" >
        <div className=" w-full bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
          <div className="relative bg-[#F7F7F7] text-center p-[5%]">
          <img className='w-[150px] mx-auto h-full' src={logo} alt="" />
          </div>

          <div className="p-5 space-y-3">
            {datas && datas.Token === "" ? (
              <div className=" flex justify-center items-center">
                <h1 className="font-QMedium text-[#021763] text-center text-xl max-[425px]:text-lg ">
                  No data available
                </h1>
              </div>
            ) : (
              <div>


                {isLoading ? (
                  <div>
                    <div className="pt-4 text-center text-gray-600 font-QRegular">
                      Fetching your data...
                    </div>
                    <img className="h-[60px] mx-auto" src={loading} alt="" />
                  </div>
                ) : error ? (
                  <div className="p-4 text-center font-QMedium text-red-500">{error}</div>
                ) : datas ? (
                  <div>
                    <div className="flex justify-center font-QSemiBold text-[#021763]">
                      <h3 className="text-xl max-[425px]:text-lg mr-[1%]">
                        Your Order
                      </h3>
                      <h3 className="text-xl max-[425px]:text-lg ml-[1%]">
                        {datas.Token}
                      </h3>
                    </div>

                    <h1 className="text-center text-xl max-[425px]:text-lg font-QSemiBold text-[#021763]">
                      is
                    </h1>

                    <div className="text-center font-QSemiBold bg-[#021763] text-white rounded-sm w-[50%] mx-auto p-[3%]">
                      <h1>{datas.StatusDescription}</h1>
                    </div>
                  </div>
                ) : (
                  <div className="p-4 text-center text-gray-500">No data available</div>
                )}
              </div>
            )}
          </div>
        </div>
        
          {datas && datas.Token !=="" && (
            <div>
                <h4 className="font-QRegular mt-[10px] text-[#021763] text-center max-[400px]:text-[12px]" >Thank you for your visit.Looking for you again</h4>
            </div>
            
          )}
        </div>

        
      </div>
    </div>

  );
};

export default UserProfile;
